import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  exportOverviewReport,
  getAllDahsbordRightCardStore,
  getBusinessByClient,
  getBusinessDetails,
  getBusinessNameData,
  getOverviewChartData,
  getOverviewData,
  resetChartData,
  resetOverAllCount,
  resetState,
  setChartUi,
} from "../../store/overview";

function useOverview() {
  const dispatch = useDispatch();
  const overview = useSelector((state) => state.overview || {});
  const {
    businessName = null,
    chartData: overviewChartData = [],
    data: businesOptions = null,
    flaggedConcerns = [],
    overallCount: overAllDatas = null,
    topCategories = [],
    trends = [],
    ui: uiWidget = {},
  } = overview;

  const getOverallBussiness = useCallback(
    (params) => dispatch(getOverviewData(params)),
    [dispatch]
  );
  const getBusinessActions = useCallback(
    (params) => dispatch(getBusinessNameData(params)),
    [dispatch]
  );
  const getChartDataAction = useCallback(
    (params) => dispatch(getOverviewChartData(params)),
    [dispatch]
  );
  const getBusinessClientAction = useCallback(
    (params) => dispatch(getBusinessByClient(params)),
    [dispatch]
  );
  const getBusinessAction = useCallback(
    (params) => dispatch(getBusinessDetails(params)),
    [dispatch]
  );
  const getOverviewReportAction = useCallback(
    (params) => dispatch(exportOverviewReport(params)),
    [dispatch]
  );
  const getMainDashboard = useCallback(
    (params) => dispatch(getAllDahsbordRightCardStore(params)),
    [dispatch]
  );
  const resetUiAction = useCallback(() => dispatch(setChartUi()), [dispatch]);
  const resetData = useCallback(() => dispatch(resetState()), [dispatch]);
  const resetOverviewDataAction = useCallback(
    () => dispatch(resetOverAllCount()),
    [dispatch]
  );
  const resetChartDataAction = useCallback(
    () => dispatch(resetChartData()),
    [dispatch]
  );

  return {
    getOverallBussiness,
    getBusinessActions,
    getChartDataAction,
    businesOptions,
    overAllDatas,
    uiWidget,
    overviewChartData,
    resetUiAction,
    resetData,
    resetOverviewDataAction,
    resetChartDataAction,
    getBusinessClientAction,
    getBusinessAction,
    businessName,
    getOverviewReportAction,
    getMainDashboard,
    topCategories,
    trends,
    flaggedConcerns,
  };
}

export default useOverview;
